var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.5299 19.9995C15.2799 19.9995 15.0299 19.9095 14.8299 19.7095L7.71992 12.7495C7.52992 12.5595 7.41992 12.3095 7.41992 12.0395C7.41992 11.7695 7.52992 11.5195 7.71992 11.3295L14.8699 4.24953C15.2599 3.85953 15.8899 3.85953 16.2799 4.24953C16.6699 4.63953 16.6599 5.27953 16.2799 5.65953L9.84992 12.0295L16.2299 18.2795C16.6199 18.6695 16.6299 19.2995 16.2499 19.6895C16.0499 19.8895 15.7899 19.9895 15.5399 19.9895L15.5299 19.9995Z",
  fill: "inherit"
})));
export default SvgChevronLeft;